import script from "./WorkingBranchSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkingBranchSelector.vue?vue&type=script&setup=true&lang=js"

import "./WorkingBranchSelector.vue?vue&type=style&index=0&id=8ce7e4de&lang=css"

const __exports__ = script;

export default __exports__